export namespace QueryParams {
  export const DocumentNum = 'documentNum'
  export const Cups = 'cups'
  export const OrderProp = 'orderProp'
  export const OrderDirection = 'orderDirection'
  export const CurrentPage = 'page'
  export const FromDate = 'fromDate'
  export const ToDate = 'toDate'
  export const Active = 'isActive'
}